/**
 * Generated by orval v7.13.0 🍺
 * Do not edit manually.
 * My App
 * This is an awesome app!
 * OpenAPI spec version: 1.0.0
 */

/**
 * @nullable
 */
export type PropertyApiResourceStatus = typeof PropertyApiResourceStatus[keyof typeof PropertyApiResourceStatus] | null;


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PropertyApiResourceStatus = {
  getting_started: 'getting_started',
  onboarding: 'onboarding',
  live: 'live',
} as const;
